import { render, staticRenderFns } from "./tabbar-harta-alih.vue?vue&type=template&id=8d89fc5c&"
import script from "./tabbar-harta-alih.vue?vue&type=script&lang=js&"
export * from "./tabbar-harta-alih.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports